import React, { useEffect, useState, useContext } from 'react'
import Progresbbar from './Progresbbar'
import TeamInfoStatic from './TeamInfoStatic'
import StaticLineUp from './StaticLineUp'
import { useNavigate, useLocation } from 'react-router-dom'
import HeadAll from '../headtohead/HeadAll'
import  DataFetch  from '../../Context/DataFetch'
import  Language  from '../../Context/Language'
import axios from "axios";
import Loading from '../Loading'


export default function StaticAll() {
  const [statics , setstatic] = useState(true)
  const {StaticsHome , StaticsAway , MacthDataBetween ,ApiUrl} = useContext(DataFetch)
  const location = useLocation();
  const datalang = useContext(Language)
  const [SporEventPlayer , setSporEventPlayer] = useState([])
  const [StatisHomes ,setStatisHomes] = useState([])
  const [StatisAways ,setStatisAways] = useState([])
  // const [ApiUrl , setApiUrl] = useState("https://srstat.cdncomm.com")
  const [loadingStat , setloadingStat] = useState(true)
  const [StatisAllData , setStatisAllData]   = useState([])
  const  [StassAll , setStassAll] = useState([])
  const  [StassFirst , setStassFirst] = useState([])
  const  [StassSecond , setStassSecond] = useState([])
  const [StatsActiveNumber , setStatsActiveNumber] = useState("0")
  const [loadingSt , setloadingSt] = useState()

  const TeamsInfoDataFunc = async () => {
    var date = new Date();
    var offsetInMinute = (date.getTimezoneOffset() / 60 ) *60;
    axios.get(`${ApiUrl}/api/SportEventPlayersStatistic?sportEventId=${location.state.MatchData.sportEvent_Id}&lang=en`)
    .then(res => {
      if(res.data.isScreenValidate !== false) {
        setSporEventPlayer(res.data.params.result)
      }
      else{
        setloadingStat(false)
      }
 
    })

    };



    const BeetweenMatchDataFunc = async () => {
      var date = new Date();
      var offsetInMinute = (date.getTimezoneOffset() / 60 ) *60;

      axios.get(`${ApiUrl}/api/SportEventCompetitorsStatistic?sportEventId=${location.state.MatchData.sportEvent_Id}&lang=en`)
      .then(res => {
        if(res.data.isScreenValidate !== false && res.data.params.length !==0){
          setStassAll(res.data.params.result[0].teamStatisticsData.filter(i => i.period === "ALL")[0].groups)
          setStassFirst(res.data.params.result[0].teamStatisticsData.filter(i => i.period === "1ST")[0].groups)
          setStassSecond(res.data.params.result[0].teamStatisticsData.filter(i => i.period === "2ND")[0].groups)
          setloadingStat(false)
        }
        else{
          setloadingStat(false)
          setloadingSt(true)
        }
      })
  
      };




  
  useEffect(() => {
    TeamsInfoDataFunc();
    BeetweenMatchDataFunc();
    window.scrollTo(0, 0);
  } ,[])

  return (
    loadingStat ? 
    <div className='H2HRootContainerArea'>
    <Loading/>
   </div>
   :

    location.state.MatchData.length !== 0 ?

    <div className='StaticContainerArea'>
        <TeamInfoStatic MatchData={location.state.MatchData}/>
        <hr className="new4"></hr>
        <div className='StaticProgressArea'>
         <div className='StaticButtonArea'>
             <div onClick={(()=> setstatic(true))} className={`StaticButtonStatic ${statics ? 'ActiveButtonStatic' : ""}`}><div className='StaticButtonStaticPlayers'>{datalang[sessionStorage.getItem("lang")].Statistics}</div></div>
             <div onClick={(()=> setstatic(false))} className={`StaticsButtonPlayers ${statics ? '' : "ActiveButtonStatic"}`}><div className='StaticButtonStaticPlayers'>{datalang[sessionStorage.getItem("lang")].Players}</div></div>
         </div>

          {
                 statics ?
                 <div className='ProgressBarAllContainer'>
                  {
                       loadingSt !==true && StassAll.length !==0 ?
                    <div>
                      <div className='StaticAllFirstSecondArea'>
                        <div className= {StatsActiveNumber === "0" ? 'ActiveBtn':""} onClick={() => setStatsActiveNumber("0")} id='AllButton'>{datalang[sessionStorage.getItem("lang")].All}</div>
                        <div className= {StatsActiveNumber === "1" ? 'ActiveBtn':""} onClick={() => setStatsActiveNumber("1")}  id='FirstButton'>{datalang[sessionStorage.getItem("lang")].FIRSTST}</div>
                        <div className= {StatsActiveNumber === "2" ? 'ActiveBtn':""} onClick={() => setStatsActiveNumber("2")}  id='SecondHalf'>{datalang[sessionStorage.getItem("lang")].SECONDST}</div>
                      </div>
                      {
                         StassAll.filter(i => i.groupName === "Possession")[0].statisticsItems.filter(i => i.name === "Ball possession").length !== 0? 
                         <Progresbbar İmageSrc={"/football-ball.png"}  Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Possession")[0].statisticsItems[0].home.split("%")[0])} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Possession")[0].statisticsItems[0].away.split("%")[0])} Title={datalang[sessionStorage.getItem("lang")].possession+"%"} />
                         :
                         ""
                      }
                    
                      {
                        StassAll.filter(i => i.groupName === "Passes")[0].statisticsItems.filter(i => i.name === "Passes").length !== 0? 
                        <Progresbbar İmageSrc={"/football-ball.png"} Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Passes")[0].statisticsItems.filter(i => i.name === "Passes")[0].home)} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Passes")[0].statisticsItems.filter(i => i.name === "Passes")[0].away)} Title={datalang[sessionStorage.getItem("lang")].Passes} />
                        :
                        ""
                      }
                     
                      {
                        StassAll.filter(i => i.groupName === "Shots")[0].statisticsItems.filter(i => i.name === "Total shots").length !== 0? 
                        <Progresbbar İmageSrc={"/football-ball.png"}  Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Shots")[0].statisticsItems.filter(i => i.name === "Total shots")[0].home)} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Shots")[0].statisticsItems.filter(i => i.name === "Total shots")[0].away)} Title={datalang[sessionStorage.getItem("lang")].TotalShot} />
                        :
                        ""
                      }
                     
                      {
                         StassAll.filter(i => i.groupName === "Shots")[0].statisticsItems.filter(i => i.name === "Shots on target").length !== 0? 
                         <Progresbbar İmageSrc={"/football-ball.png"}  Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Shots")[0].statisticsItems.filter(i => i.name === "Shots on target")[0].home)} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "Shots")[0].statisticsItems.filter(i => i.name === "Shots on target")[0].away)} Title={datalang[sessionStorage.getItem("lang")].ShotonTarget} />
                         :
                         ""
                      }
                     
                      {
                         StassAll.filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Corner kicks").length !== 0? 
                         <Progresbbar İmageSrc={"/corner.png"} Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Corner kicks")[0].home)} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Corner kicks")[0].away)} Title={datalang[sessionStorage.getItem("lang")].Corner} />
                         :
                         ""
                      }
                     
                      {
                        StassAll.filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Offsides").length !== 0? 
                        <Progresbbar İmageSrc={"/offside-flag.png"} Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Offsides")[0].home)} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Offsides")[0].away)} Title={datalang[sessionStorage.getItem("lang")].Offside} />
                        :
                        ""
                      }

                      {
                         StassAll.filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Yellow cards").length !== 0? 
                         <Progresbbar İmageSrc={"/yellow-card.png"} Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Yellow cards")[0].home)} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Yellow cards")[0].away)} Title={datalang[sessionStorage.getItem("lang")].YellowCard} />
                         :
                         ""
                      }

                         {
                           StassAll.filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Red cards").length !== 0? 
                           <Progresbbar  İmageSrc={"/red-card.png"} Home={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Red cards")[0].home )} Away={parseInt((StatsActiveNumber === "0" ?  StassAll: StatsActiveNumber ==="1" ? StassFirst: StatsActiveNumber ==="2" ? StassSecond : StassAll).filter(i => i.groupName === "TVData")[0].statisticsItems.filter(i => i.name === "Red cards")[0].away)} Title={datalang[sessionStorage.getItem("lang")].RedCard} /> 
                           :
                           ""
                         }

                  </div>
                  :
                  <div className='DATANOTFOUNDDİV'>
                  <div>{datalang[sessionStorage.getItem("lang")].Nodata}</div>
                 </div>
                  }
                 </div>
                 :
                 <StaticLineUp MatchData={location.state.MatchData } lineUp={SporEventPlayer}  />

          }

        </div>
    </div>
   :
     <div className='DATANOTFOUNDDİV'>
       <div>{datalang[sessionStorage.getItem("lang")].Nodata}
       </div>
     </div>
  )
}
